import React, { useState, useEffect } from 'react';
import './HeroSection.css';

const HeroSection = () => {
  const [currentScene, setCurrentScene] = useState(0);
  const [showText, setShowText] = useState(false);
  const [showSecondText, setShowSecondText] = useState(false);
  const [showThirdText, setShowThirdText] = useState(false);
  const [showFourthText, setShowFourthText] = useState(false);
  const [showFinalText, setShowFinalText] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const animationCycle = () => {
      // Reset all states
      setShowText(false);
      setShowSecondText(false);
      setShowThirdText(false);
      setShowFourthText(false);
      setShowFinalText(false);
      setCurrentScene(0);
      setIsTransitioning(false);
      
      // Scene 1: First text pair
      setTimeout(() => setShowText(true), 1000);
      setTimeout(() => setShowSecondText(true), 4000);
      
      // Hide Scene 1 and transition to Scene 2
      setTimeout(() => {
        setShowText(false);
        setShowSecondText(false);
      }, 8000);
      
      setTimeout(() => setCurrentScene(1), 8500);
      setTimeout(() => setShowThirdText(true), 9000);
      setTimeout(() => setShowFourthText(true), 12000);
      
      // Hide Scene 2 and transition to Scene 3
      setTimeout(() => {
        setShowThirdText(false);
        setShowFourthText(false);
      }, 15000);
      
      setTimeout(() => setCurrentScene(2), 15500);
      setTimeout(() => setShowFinalText(true), 16000);
      
      // Start fading out text and begin blue transition
      setTimeout(() => setShowFinalText(false), 20000);
      setTimeout(() => setIsTransitioning(true), 20000);
      setTimeout(() => setCurrentScene(3), 20500);
      
      // Complete blue transition by the time first scene starts
      setTimeout(() => setIsTransitioning(false), 22000);
    };
    
    // Start first cycle
    animationCycle();
    
    // Repeat every 24 seconds
    const interval = setInterval(animationCycle, 24000);
    
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <section 
      className={`cb02_rcm_banner scene-${currentScene === 0 ? 'one' : currentScene === 1 ? 'two' : currentScene === 2 ? 'three' : 'blue'} ${isTransitioning ? 'transitioning' : ''}`}
    >
      {/* Background Pattern */}
      <div className="background-pattern"></div>
      
      {/* Main Container */}
      <div className="banner-container layout-enhanced5">
        {/* Left Content Column */}
        <div className="content-column">
          {/* Left Decorative SVG */}
          <svg className="deco" width="30" height="56" viewBox="0 0 30 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5723 22.6284C12.9764 23.414 13.4048 24.1934 13.7727 25.0033C14.0321 25.5757 13.9356 26.1481 13.5978 26.6901C13.3324 27.1103 13.1152 27.5609 12.8799 27.9993C12.8377 28.0724 12.8437 28.1759 12.8317 28.2612C11.3537 27.0372 11.0581 24.2848 12.5783 22.6284H12.5723Z" fill="#BBA984"/>
            <path d="M24.5342 13.427C24.6669 12.7998 24.7815 12.1665 24.9384 11.5393C25.3305 9.98647 26.0303 8.55544 26.7602 7.14268C27.1161 6.46066 27.5143 5.80909 28.0934 5.29149C28.6122 4.82869 29.2034 4.55466 29.9997 4.54248C27.5867 7.18531 26.0725 10.2909 24.6247 13.4453C24.5945 13.4392 24.5643 13.427 24.5342 13.4209V13.427Z" fill="#BBA984"/>
            <path d="M0 4.56078C0.567062 4.53642 0.995375 4.68865 1.39956 4.93223C2.09934 5.35241 2.58194 5.97353 2.96803 6.67382C3.7402 8.06831 4.44601 9.48716 4.89845 11.0217C5.10959 11.7342 5.22421 12.471 5.38106 13.2017C5.39916 13.287 5.41725 13.3722 5.43535 13.4636C3.92117 10.3397 2.43716 7.20361 0 4.56078Z" fill="#BBA984"/>
          </svg>
          
          {/* Decorative Elements */}
          <span id="deco-line" aria-hidden="true"></span>
          <span id="deco-circle" aria-hidden="true"></span>
          
          {/* Content Wrapper */}
          <div className="header-wrapper">
            {/* Scene 1 Content */}
            <div className={`scene-content scene-one-content ${currentScene !== 0 ? 'fade-out' : ''}`}>
              <div className={`animated-text first-text ${showText ? 'visible' : ''}`}>
                <p className="hero-intro">
                  For three decades, Rayad Group has led global innovation, shaping industries and driving progress.
                </p>
              </div>
              <div className={`animated-text second-text ${showSecondText ? 'visible' : ''}`}>
                <h1 className="hero-highlight script-text">
                  Strategic Pathways to<br/>Global Citizenship
                </h1>
              </div>
            </div>

            {/* Scene 2 Content */}
            <div className={`scene-content scene-two-content ${currentScene !== 1 ? 'fade-out' : 'fade-in'}`}>
              <div className={`animated-text third-text ${showThirdText ? 'visible' : ''}`}>
                <p className="hero-intro">
                  We deliver comprehensive solutions across six continents, connecting clients to
                </p>
              </div>
              <div className={`animated-text fourth-text ${showFourthText ? 'visible' : ''}`}>
                <h2 className="hero-highlight script-text-italic">
                  Global Opportunities<br/>and Exceptional Outcomes
                </h2>
              </div>
            </div>

            {/* Scene 3 Content */}
            <div className={`scene-content scene-three-content ${currentScene !== 2 ? 'fade-out' : 'fade-in'}`}>
              <div className={`animated-text final-content ${showFinalText ? 'visible' : ''}`}>
                <h1 className="hero-title">
                  <span>Expect</span> <span>the</span>
                  <br />
                  <span id='line'></span>
                  <span>Exceptional</span>
                </h1>
                <h2 className="hero-description">
                  Global solutions in immigration, cybersecurity, corporate formation, healthcare, education technology, and strategic investment advisory.
                </h2>
                <a href="#portfolio" className="btn btn-white">Explore Our Services</a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Right Content Column - Image Section */}
        <div className="image-column">
          <div className="image-wrapper relative">
            <div className="hero-image-container image-main">
              <img src="/images/img_20250721_091750.png" alt="Business Partners" className="image-fill" />
            </div>
            <div className="hero-image-container image-overlay">
              <img src="/images/business-person.avif" alt="Business Professional" className="image-fill" />
            </div>
            
            {/* Enhanced Elements */}
            <div className="hero-image-container image-portfolio">
              <img src="/images/view-city.jpg" alt="City Business District" className="image-fill" />
            </div>
            <div className="elegant-border"></div>
            <div className="luxury-seal">
              <div className="seal-inner">
                <span className="seal-text">ESTABLISHED</span>
                <span className="seal-year">1994</span>
              </div>
            </div>
            <div className="floating-elements">
              <div className="float-element fe-1"></div>
              <div className="float-element fe-2"></div>
              <div className="float-element fe-3"></div>
            </div>
            
            {/* Elegant decorative element */}
            <div className="image-decoration">
              <div className="decoration-line"></div>
              <div className="decoration-accent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;